import declare from "dojo/_base/declare";
import Table from "csi/table/Widget";
import { getCustomViewContainerKeyForType } from "csi/model/customView";

const BOMSectionTable = declare(Table, {
	/**
	 * @override
	 * Changing the prefKey because BOM views in DataSetup are in htmlView, so can not change the prefKey through DataSetupContent.
	 * Changing the prefKey here ensures the BOM Views in DataSetup have the same format of PreferenceView Container as other DataSetup Views
	 */
	_resolveView() {
		this.inherited(arguments);
		this.prefKey = getCustomViewContainerKeyForType("BOMSectionDefinition", null, this.defView.getPageRelationship()?.pathHints);
	},
});

export = BOMSectionTable;
